<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <v-data-table
        :headers="headers"
        :items="lists"
        item-key="`${type}`/${id}"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.description`]="{ item }">
          {{ item.description }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <small>{{
            item.type == "PRODUCT" ? "PRODUTO" : "MEDICAMENTO"
          }}</small>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <div>
              <v-btn
                x-small
                class="text-twenty btn-print p-1"
                @click="handleToTable(item.id, 1)"
              >
                <i class="fas fa-print mr-2"></i>
                ESTOQUE ATUAL E PRODUTOS QUE PRECISA COMPRAR
              </v-btn>
            </div>
            <div>
              <v-btn
                x-small
                class="text-twenty btn-print p-1"
                @click="handleToTable(item.id, 2)"
              >
                <i class="fas fa-print mr-2"></i>
                PRODUTOS QUE PRECISA COMPRAR
              </v-btn>
            </div>
            <div>
              <v-btn
                x-small
                class="text-twenty btn-print p-1"
                @click="handleToTable(item.id, 3)"
              >
                <i class="fas fa-print mr-2"></i>
                ESTOQUE ATUAL DE PRODUTOS
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import routes from "../../../routes";

import api from "../../../services/api";

export default {
  name: "List",
  components: {},
  data() {
    return {
      resident_id: "",

      total: 0,
      options: {},
      search: "",
      headers: [
        { text: "NOME", value: "description" },
        { text: "TIPO", value: "type" },
        { text: "TOTAL DE ITEMS ATIVOS", value: "total_list_items" },
        { text: "AÇÕES", value: "actions" },
      ],
      lists: [],

      loading: false,
      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;
    },

    async paginate() {
      try {
        this.loading = true;

        const { rest_home_id, resident_id, search } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        let params = {
          rest_home_id,
          resident_id,
          status: 1,
          page,
          itemsPerPage,
          search,
          sortBy,
          sortDesc,
        };

        const response = await api.get("/rest-home/lists/paginate", {
          params,
        });

        const { error, errors, lists, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.lists = lists;
          this.total = total;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToTable(id, type) {
      routes.push({
        name: "list-table",
        params: { id, type },
        query: { resident_id: this.resident_id },
      });
    },
  },
};
</script>